// Module
var code = "<div class=\"vt-widget\">\n    <div class=\"vt-widget__header\">\n        Cancellation policy\n    </div>\n    <div class=\"vt-widget__body\">\n        <div class=\"margin-top-5\">\n            <div>\n                <span data-ng-bind-html=\"::cancellationPolicy\"></span>\n            </div>\n        </div>\n    </div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/profile/widget/profile-cancellation-policy.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;